// 

import { useAtom } from "jotai";
import { current_language } from "state/store.global";

export const Language = () => {
  
  const language = useAtom(current_language)[0];
  
  return null

}